var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('limit-editor',{attrs:{"service":_vm.lottoServiceInstance,"endpoint-config":_vm.endpointConfig,"preset-config":_vm.presetConfig}})}
var staticRenderFns = []

export { render, staticRenderFns }